$(document).ready(function() {
	$('.rating-star').hover(function() {
		for (i=0; i<=5; i++) {
			$('.rating-star-' + i).css("color", "orage!important");
			$('.rating-star-' + i).addClass("rated-star-hover-not-fill")
		}

		for (i=0; i<=this.id; i++) {
			$('.rating-star-' + i).css("color", "orage!important");
			$('.rating-star-' + i).addClass("rated-star-hover")
		}
	}, function() {
		for (i=0; i<=5; i++) {
			$('.rating-star-' + i).removeClass("rated-star-hover-not-fill")
		}
		for (i=0; i<=this.id; i++) {
			$('.rating-star-' + i).removeClass("rated-star-hover")
		}
	})
})
